<template>
  <div class="main-view">
    <!-- 顶部radio切换 -->
    <el-radio-group v-model="activeType" style="margin-bottom:10px;">
      <el-radio-button label="pay">支付交易</el-radio-button>
      <el-radio-button label="score">积分交易</el-radio-button>
    </el-radio-group>

    <!-- 动态组件核心 -->
    <component :is="currentComponent" />
  </div>
</template>

<script>
// 引入两个子组件
import PayTable from './components/PayTable.vue'
import ScoreTable from './components/ScoreTable.vue'
export default {
  components: { PayTable, ScoreTable },
  data() {
    return {
      activeType: 'pay' // 默认支付交易
    }
  },
  computed: {
    currentComponent() {
      // 根据选中类型返回组件名
      return this.activeType === 'pay' ? 'PayTable' : 'ScoreTable'
    }
  }
}
</script>
